import { createDefaultMutationHook } from "hooks/useMutationHandler";

import { TOFU_WORKSPACE_UNLOCK } from "./gql";

const useUnlockTofuWorkspace = createDefaultMutationHook(TOFU_WORKSPACE_UNLOCK);

export default useUnlockTofuWorkspace;
